/**
 * Shared layout primitives for the recipe showcase sections.
 *
 * Imports ONLY from the shared UI barrel and @/lib/cn (workshop rules).
 */

import { menuItemVariants } from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/cn";

export function Section({
  name,
  title,
  caption,
  children,
}: {
  name: string;
  title: string;
  caption: string;
  children: React.ReactNode;
}) {
  return (
    <section className="mb-12" data-testid={`workshop-recipe-${name}`}>
      <h2 className="text-appkit-body font-semibold text-primary">{title}</h2>
      <p className="mt-1 text-appkit-caption text-muted">{caption}</p>
      <div className="mt-4">{children}</div>
    </section>
  );
}

export function Row({ children }: { children: React.ReactNode }) {
  return <div className="flex flex-wrap items-center gap-4">{children}</div>;
}

export function Label({ children }: { children: React.ReactNode }) {
  return (
    <span className="w-full text-appkit-mini uppercase tracking-wide text-muted">
      {children}
    </span>
  );
}

/** Static menu item styled with the shared menuItemVariants recipe. */
export function StaticMenuItem({
  icon,
  destructive,
  children,
}: {
  icon: React.ReactNode;
  destructive?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        menuItemVariants(),
        destructive ? "text-red-400" : "text-secondary",
      )}
      role="menuitem"
    >
      {icon}
      {children}
    </div>
  );
}
